import { ProcessGeneral } from 'api/endpoints/processes';
import BaseRepo from 'container/BaseRepo';
import { buildBadRequestApiError } from 'container/helpers/errors';
import { ApiResponseAsync, isApiError } from 'container/models';
import { SearchRequestTyped } from 'container/search';

import {
  DriverSettlementsLog,
  IDriverSettlementsLogRepo,
} from './IDriverSettlementsLogRepo';

export class DriverSettlementsLogRepo
  extends BaseRepo
  implements IDriverSettlementsLogRepo
{
  search = async (
    draft: ProcessGeneral,
    request: SearchRequestTyped<Omit<DriverSettlementsLog, 'draftProcessId'>>
  ): ApiResponseAsync<Array<DriverSettlementsLog>> => {
    const link = draft._links?.['searchDriverSettlementsLogs'];

    if (!link) {
      return buildBadRequestApiError(
        new Error('link "search Driver Settlements logs" is not available')
      );
    }

    const searchResult = await this.helpers.executeSearch<
      DriverSettlementsLog[]
    >(link, request, { convertRequestToSnakeCase: true });
    if (isApiError(searchResult)) {
      return searchResult;
    }
    return searchResult ?? [];
  };
}
